import React from 'react';
import { findDOMNode } from 'react-dom';
import { isBrowser } from "react-device-detect";
import { TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from '../../plugins/ScrollMagic';
import globals from '../../globals';

export default {

    destroy(controller) {
        controller.destroy(true);
    },

    initialise(About, SubTitle) {
        this.scenes = [];
        this.AboutNode = findDOMNode(About);
        this.textBlocks = [...this.AboutNode.querySelectorAll('.cube .text')];

        let controller = new ScrollMagic.Controller(),
            tl = new TimelineLite();

        if (isBrowser) {
            if (SubTitle) {
                tl.fromTo(SubTitle, 1, globals.getSubAnimation(SubTitle), {backgroundPositionY: "0px", ease: Elastic.easeOut.config(1, 0.4)});
            }

            tl.staggerFromTo(this.textBlocks, 0.5, {y: -50, opacity: 0}, {y: 0, opacity: 1}, 0.2, 0.5);

            let scene1 = new ScrollMagic.Scene({
                triggerElement: '.about-trigger',
                reverse: false
            })
                .setTween(tl)
                .addTo(controller);
            this.scenes.push(scene1);

            let scene2 = new ScrollMagic.Scene({
                triggerElement: '.about',
                duration: '2000px'
            })
                .setTween(this.AboutNode, {backgroundPosition: '0px -100px'})
                .addTo(controller);
            this.scenes.push(scene2);
        }

        return controller;
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/About/animations.js